import { AP, LINKEDIN } from "~constants";
import { Story as StoryType } from "~types/types";

export default function isAPOrLinkedIn(story: StoryType) {
    const { attributor } = story;

    return (
        attributor?.toLowerCase() === AP ||
        attributor?.toLowerCase() === LINKEDIN
    );
}
